<lib-popup-header [title]="'Other'" [canMaximize]="false" [useCustomClose]="true" (popupClosed)="close()"></lib-popup-header>
<div class="w-100">

  <ejs-grid #otherVacationsGrid [dataSource]="data.popupData.other" height="300px" [id]="gridName"
    [allowExcelExport]="true" [allowSorting]="true" [allowResizing]="true" [showColumnChooser]="true"
    [allowReordering]="true" (rowDataBound)="onRowDataBound($event)" [allowFiltering]="true" [aggregates]="aggreagtes"
    [filterSettings]="{ type: 'Menu' }" [editSettings]='editSettings' (created)="onContactsGridCreated($event)"
    (actionBegin)="actionBegin($event)" (actionComplete)="actionComplete($event)"
    (commandClick)="commandClick($event)" >

    <e-columns>
      <e-column *ngFor="let column of otherVacationGridColumns;" [field]="column.field" [headerText]="column.headerText"
        [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'" [type]="column.type" [width]="column.width"
        [filter]="column.filter ? column.filter : { type: 'Menu' }" [format]="column.format ? column.format : null"
        [textAlign]="column.textAlign" [showInColumnChooser]="column.showInColumnChooser ?? true"
        [visible]="column.visible" [commands]="column?.commands ? column.commands : null" [edit]="column.edit"
        [allowReordering]="column.allowReordering ?? true" [freeze]="column.freeze ? column.freeze: null"
        [allowEditing]="column.allowEditing" [allowSorting]="column.allowSorting"
        [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">

      <ng-template *ngIf="column?.field === 'days'" #template let-data>
        <ejs-numerictextbox [placeholder]="'Enter days'"
        [value]="data.days"
        (valueChange)="onDaysChange($event, data)"
        (change)="hasUnsavedChanges = $event.isInteracted;"
        [max]="365"
        [min]="1"
        [disabled]="!canEdit"
        [readonly]="!canEdit"
        [enabled]="canEdit"
        format="n0" [decimals]="0" [showSpinButton]="false" [validateDecimalOnType]="true">
        </ejs-numerictextbox>
      </ng-template>


      </e-column>
    </e-columns>
  </ejs-grid>
</div>

<div class="d-flex justify-content-end">
  <button class="btn btn-sm btn-danger footer-buttons my-2 me-1" (click)="close();">Close</button>
  <button *ngIf="canEdit" class="btn btn-sm btn-success footer-buttons my-2 me-2" [disabled]="!hasUnsavedChanges" (click)="close(true);">Add</button>
</div>